import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { XPToastProvider } from "@/components/leaderboard/XPToast";
import BugReportButton from "@/components/BugReportButton";
import FloatingAdminPanel from "@/components/FloatingAdminPanel";
import AvatarConsentModal from "@/components/user-panel/AvatarConsentModal";
import ErrorBoundary from "@/components/ErrorBoundary";
import AnimatedBackground from "@/components/AnimatedBackground";
import ChallengeNotificationListener from "@/components/ChallengeNotificationListener";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/hooks/useAuth";
import { useBootstrapData } from "@/hooks/useBootstrapData";
import { Outlet } from "react-router-dom";

const AppShell = () => {
  const { isAdmin, canManageTasks, pendingAvatarConsent, handleAvatarConsent, dismissAvatarConsent } = useAuth();
  useBootstrapData(); // Start public data fetch in parallel with auth — no waterfall

  return (
    <div className="min-h-screen relative flex flex-col overflow-x-hidden max-w-full">
      <Toaster />
      <Sonner />
      <XPToastProvider />
      <BugReportButton />
      {canManageTasks && <FloatingAdminPanel isAdmin={isAdmin} />}

      {pendingAvatarConsent && (
        <AvatarConsentModal
          isOpen={true}
          onClose={dismissAvatarConsent}
          avatarUrl={pendingAvatarConsent.avatarUrl}
          username={pendingAvatarConsent.username}
          onAccept={() => handleAvatarConsent(true)}
          onDecline={() => handleAvatarConsent(false)}
        />
      )}

      {/* Global, always-mounted background and header — never remount on navigation */}
      <AnimatedBackground />
      <ChallengeNotificationListener />
      <Header />

      <main className="flex-1 relative overflow-x-hidden">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>

      <Footer />
    </div>
  );
};

export default AppShell;
